<template>
  <div class="pop-swiper-modal">
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :destroy-on-close="true"
      custom-class="pop-swiper-dialog"
      :show-close="false"
      :close-on-click-modal="true"
      :modal="false"
      @open="onDialogOpen"
      @opened="initSwiper"
      @close="handleClose"
      @closed="handleClosed"
    >
      <div class="cover-swiper">
        <div class="pop" :class="{ 'is-ready': isSwiperReady }">
          <div ref="slideCarousel" class="pop-swiper__container">
            <div class="swiper-wrapper">
              <div
                v-for="(item, index) in imgList"
                :key="index"
                class="swiper-slide pop-swiper__slide"
              >
                <div class="pop-swiper__card" @click="openVideo(item, index)">
                  <img
                    class="pop-swiper__img"
                    :src="preText + (isPortrait ? item.mobSrc : item.src)"
                    alt=""
                    draggable="false"
                    :code-stm="`event, PAGEURL, 轮播图${index + 1}点击`"
                  />
                  <div class="pop-swiper__mask"></div>
                </div>
                <div class="pop-swiper__info">
                  <p class="pop-swiper__title">{{ item.title }}</p>
                  <p class="pop-swiper__tag">{{ item.tag }}</p>
                </div>
              </div>
            </div>
          </div>

          <div ref="pagination" class="pop-swiper__progress"></div>

          <i
            class="pop-swiper__close"
            @click="closeSwiper"
            code-stm="event, PAGEURL, 轮播图弹窗关闭"
          >
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                opacity="0.5"
                d="M32.7871 31.1159C33.2576 31.5873 33.2552 32.3545 32.7815 32.8292C32.3044 33.3072 31.5422 33.3064 31.0716 32.8349L16.5698 18.3214L2.0681 32.8349C1.59765 33.3062 0.831943 33.3039 0.358205 32.8292C-0.118838 32.3512 -0.118071 31.5875 0.352541 31.1159L14.8543 16.6024L0.352541 2.08892C-0.117911 1.61755 -0.115536 0.850338 0.358205 0.37567C0.835247 -0.102309 1.59749 -0.101539 2.0681 0.369995L16.5698 14.8835L31.0716 0.369995C31.542 -0.101378 32.3077 -0.0989992 32.7815 0.37567C33.2585 0.853648 33.2577 1.61739 32.7871 2.08892L18.2854 16.6024L32.7871 31.1159Z"
                fill="white"
              />
            </svg>
          </i>
        </div>
      </div>
    </el-dialog>
    <PopVideo
      :visible.sync="isShowVideo"
      :video-url="fullVideoUrl"
      :codeGa="videoCode"
      :codeStm="videoCode"
    />
  </div>
</template>

<script>
import {
  createSwiperInstance,
  destroySwiperInstance,
  getKiaBaseUrl,
} from "@/utils/swiper-common.js";
import { isPortraitFun } from "@/utils/utils.js";
import PopVideo from "./pop-video.vue";

const SWIPER_IMGS = [
{
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-4.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-4.png",
    title: "智能中控屏幕",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/part5.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-2.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-2.png",
    title: "手机如何绑定车机？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/part3.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob.png",
    title: "车载KTV如何使用？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/part1.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-1.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-1.png",
    title: "车载游戏厅如何使用？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/part2.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-3.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-3.png",
    title: "AI智能语音助手",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/part4.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-5.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-5.png",
    title: "双地图导航，轻松出行",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part6.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-6.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-6.png",
    title: "3D可视化车控，驾驭多种出行模式",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part7.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-7.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-7.png",
    title: "怎么不让长途旅行太无聊？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part8.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-8.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-8.png",
    title: "手机如何进行车机投屏？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part9.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-9.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-9.png",
    title: "如何营造惊喜氛围？",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part10.mp4"
  },
  {
    src: "/assets/~/media/images/vehicle/newseltos/swipervideos/pc/pc-10.png",
    mobSrc: "/assets/~/media/images/vehicle/newseltos/swipervideos/mob/mob-10.png",
    title: "智能场景自定义",
    tag: "",
    video: "https://img.kia.cn/media/videos/202609/Part11.mp4"
  },
];

export default {
  name: "PopSwiper",
  components: { PopVideo },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText: "https://www.kia.cn",
      imgList: SWIPER_IMGS,
      swiper: null,
      isSwiperReady: false,
      isShowVideo: false,
      fullVideoUrl: "",
      videoCode: "",
    };
  },
  methods: {
    openVideo(item, index) {
      if (this.swiper && this.swiper.allowClick === false) return;
      if (!item || !item.video) return;
      this.fullVideoUrl = item.video;
      this.videoCode = `轮播图${index + 1}视频`;
      this.isShowVideo = true;
    },
    onDialogOpen() {
      // 动画期间先隐藏轮播，避免未初始化时的样式闪烁
      this.isSwiperReady = false;
      document.body.style.overflow = "hidden";
    },
    initSwiper() {
      // 等 dialog 入场动画结束再初始化，避免父级 transform 破坏 PC 拖拽
      this.isSwiperReady = false;
      this.destroySwiper();
      this.$nextTick(() => {
        // 移动端为纵向列表，不启用横向 Swiper
        if (window.innerWidth <= 767) {
          this.isSwiperReady = true;
          return;
        }
        if (!this.$refs.slideCarousel) return;
        this.swiper = createSwiperInstance(this.$refs.slideCarousel, {
          slidesPerView: "auto",
          centeredSlides: true,
          spaceBetween: (window.innerWidth * 101) / 2200,
          loop: false,
          allowTouchMove: true,
          simulateTouch: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: this.$refs.pagination,
            type: "progressbar",
          },
        });
        this.$nextTick(() => {
          if (!this.swiper) return;
          this.swiper.update();
          this.isSwiperReady = true;
        });
      });
    },
    destroySwiper() {
      destroySwiperInstance(this.swiper);
      this.swiper = null;
      this.isSwiperReady = false;
    },
    closeSwiper() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.destroySwiper();
    },
    handleClosed() {
      this.destroySwiper();
      document.body.style.overflow = "";
    },
  },
  mounted() {
    this.preText = getKiaBaseUrl();
  },
  beforeDestroy() {
    this.destroySwiper();
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";

.pop-swiper-modal {
  position: relative;
  z-index: 0;
}

::v-deep .pop-swiper-dialog {
  width: 100vw;
  margin-top: 0 !important;
  background: transparent;
  box-shadow: none;
}

::v-deep .pop-swiper-dialog .el-dialog__header {
  display: none;
  padding: 0;
}

::v-deep .pop-swiper-dialog .el-dialog__body {
  padding: 0;
}

.cover-swiper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(21, 28, 34, 0.8);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  z-index: 1000;
}

.pop {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
}

.pop-swiper__container,
.pop-swiper__progress {
  opacity: 0;
  visibility: hidden;
}

.pop.is-ready .pop-swiper__container,
.pop.is-ready .pop-swiper__progress {
  opacity: 1;
  visibility: visible;
}

.pop-swiper__container {
  width: 100%;
  overflow: hidden;
  user-select: none;

  @media (max-width: 767px) {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767px) {
  .pop-swiper__container ::v-deep .swiper-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    transform: none !important;
    padding: calc(319 / 1125 * 100vw) 0 calc(120 / 1125 * 100vw);
  }
}

.pop-swiper__slide {
  width: calc(1244 / 2200 * 100vw);
  height: auto;

  @media (max-width: 767px) {
    width: calc(989 / 1125 * 100vw);
    padding-bottom: calc(69 / 1125 * 100vw);
    flex-shrink: 0;
  }
}

.pop-swiper__card {
  position: relative;
  width: 100%;
  height: calc(700 / 2200 * 100vw);
  border-radius: calc(30 / 2200 * 100vw);
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 767px) {
    height: calc(557 / 1125 * 100vw);
    border-radius: calc(24 / 1125 * 100vw);
  }
}

.pop-swiper__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-user-drag: none;
  user-select: none;
}

.pop-swiper__mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.2;
  pointer-events: none;
}

.pop.is-ready .pop-swiper__mask {
  transition: opacity 0.3s ease;
}

::v-deep .swiper-slide-active .pop-swiper__mask,
.pop-swiper__slide:first-child .pop-swiper__mask {
  opacity: 0;
}

.pop.is-ready ::v-deep .swiper-slide:not(.swiper-slide-active) .pop-swiper__mask {
  opacity: 0.2;
}

@media (max-width: 767px) {
  .pop-swiper__mask,
  .pop-swiper__slide:first-child .pop-swiper__mask,
  .pop.is-ready ::v-deep .swiper-slide:not(.swiper-slide-active) .pop-swiper__mask {
    opacity: 0.2;
  }
}

.pop-swiper__info {
  margin-top: calc(35 / 2200 * 100vw);
  padding-left: calc(6 / 2200 * 100vw);

  @media (max-width: 767px) {
    margin-top: calc(50 / 1125 * 100vw);
    padding-left: 0;
  }
}

.pop-swiper__title {
  margin: 0;
  color: #fff;
  font-size: calc(28 / 2200 * 100vw);
  line-height: 1.5;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: calc(46 / 1125 * 100vw);
  }
}

.pop-swiper__tag {
  margin: 0;
  color: #fff;
  opacity: 0.5;
  font-size: calc(18 / 2200 * 100vw);
  line-height: 1.5;
  letter-spacing: 0.1em;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: calc(29 / 1125 * 100vw);
  }
}

.pop-swiper__progress {
  width: calc(688 / 2200 * 100vw);
  height: 1px;
  margin-top: calc(80 / 2200 * 100vw);

  @media (max-width: 767px) {
    display: none;
  }
}

::v-deep .pop-swiper__progress.swiper-pagination-progressbar {
  position: relative;
  left: auto;
  top: auto;
  background-color: rgba(255, 255, 255, 0.3);
}

::v-deep .pop-swiper__progress .swiper-pagination-progressbar-fill {
  background-color: #ffffff;
}

.pop-swiper__close {
  position: absolute;
  top: calc(53 / 2200 * 100vw);
  right: calc(80 / 2200 * 100vw);
  width: calc(33 / 2200 * 100vw);
  height: calc(33 / 2200 * 100vw);
  cursor: pointer;
  line-height: 0;
  z-index: 2;

  svg {
    width: 100%;
    height: 100%;
    display: block;
    pointer-events: none;
  }

  &:hover path {
    opacity: 1;
  }

  @media (max-width: 767px) {
    top: calc(133 / 1125 * 100vw);
    right: calc(68 / 1125 * 100vw);
    width: calc(66 / 1125 * 100vw);
    height: calc(66 / 1125 * 100vw);
  }
}
</style>
